import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios, { authHeaders } from "../../utils/axios";

export const reqToGetAllBank = createAsyncThunk("bank/reqToGetAllBank",async ({limit, page, search, is_active},{ rejectWithValue }) => {
    try {
      const response = await Axios.get(`${process.env.REACT_APP_BASE_URL}/banks?limit=${limit || 10}&page=${page || 1}&search=${search || ""}&is_active=${is_active}`,authHeaders());      
      return response?.data; // Success case
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message); // Error case
    }
});

export const reqToGetBankDetails = createAsyncThunk("bank/reqToGetBankDetails",async ({id},{ rejectWithValue }) => {
  try{
   const response = await Axios.get(`${process.env.REACT_APP_BASE_URL}/banks/${id}`,authHeaders());   
   return response.data; // Success case
  }catch(error){
    return rejectWithValue(error.response?.data || error.message); // Error case
  }
});

export const reqToGetBankStats = createAsyncThunk("bank/reqToGetBankStats",async (_,{ rejectWithValue }) => {
  try{
   const response = await Axios.get(`${process.env.REACT_APP_BASE_URL}/banks/stats`,authHeaders());      
   return response.data; // Success case
  }catch(error){
    return rejectWithValue(error.response?.data || error.message); // Error case
  }
});

export const reqToGetBankBranchDetails = createAsyncThunk("bank/reqToGetBankBranchDetails",async ({id,search,limit,page, is_active},{ rejectWithValue }) => {
  try{
   const response = await Axios.get(`${process.env.REACT_APP_BASE_URL}/branches?bank_ids=${id}&search=${search || ""}&limit=${limit || 10}&page=${page || 1}&is_active=${is_active}`,authHeaders());
   return response.data; // Success case
  }catch(error){
    return rejectWithValue(error.response?.data || error.message); // Error case
  }
});

export const reqToAddBranch = createAsyncThunk("bank/reqToAddBranch",async ({data}, { rejectWithValue }) => {
  try {
    const response = await Axios.post(`${process.env.REACT_APP_BASE_URL}/branches`,data,authHeaders());
    return response.data; // Success case
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message); // Error case
  }
});

export const reqToAddBank = createAsyncThunk("bank/reqToAddBank",async ({data}, { rejectWithValue }) => {
  try {
    const auth = authHeaders();

    const response = await Axios.post(`${process.env.REACT_APP_BASE_URL}/banks`,data,
        {
          headers: {
            ...auth.headers,    
            "Content-Type": "multipart/form-data",
          },
        });
    return response.data; // Success case
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message); // Error case
  }
});

export const updateBankStatus = createAsyncThunk(
  "bank/updateBankStatus",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const auth = authHeaders();
      const response = await Axios.patch(
        `${process.env.REACT_APP_BASE_URL}/banks/${id}`,
        data,
        {
          headers: {
            ...auth.headers,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const reqToUpdateBank = createAsyncThunk(
  "bank/reqToUpdateBank",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const auth = authHeaders();
      const response = await Axios.patch(
        `${process.env.REACT_APP_BASE_URL}/banks/${id}`,
        data,
        {
          headers: {
            ...auth.headers,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const updateBranchStatus = createAsyncThunk(
  "bank/updateBranchStatus",
  async ({ id, is_active }, { rejectWithValue }) => {
    try {
      const response = await Axios.patch(
        `${process.env.REACT_APP_BASE_URL}/branches/${id}`,
        { is_active },
        authHeaders()
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const reqToUpdateBranch = createAsyncThunk(
  "bank/reqToUpdateBranch",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await Axios.patch(
        `${process.env.REACT_APP_BASE_URL}/branches/${id}`,
        data,
        authHeaders()
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

const bankSlice = createSlice({
    name: "bank",
    initialState:{
        error: null,
        isLoading: false,
        isBranchLoading: false,
        banks:[],
        bankStats:{},
        bankDetails:{},
        bankBranchDetails:[],
    },
    reducer:{},
    extraReducers: (builder) => {
    builder
    .addCase(reqToGetAllBank.fulfilled, (state, action) => {
        state.isLoading = false;
        state.banks = action.payload;
    })
    .addCase(reqToGetAllBank.pending, (state) => {
          state.isLoading = true;
        })
    .addCase(reqToGetAllBank.rejected, (state) => {
          state.isLoading = false;
        })
    .addCase(reqToGetBankDetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.bankDetails = action.payload;
    })
    .addCase(reqToGetBankBranchDetails.pending, (state) => {
      state.isBranchLoading = true;
    })
    .addCase(reqToGetBankBranchDetails.fulfilled, (state, action) => {
      state.isBranchLoading = false;
      state.bankBranchDetails = action.payload;
    })
    .addCase(reqToGetBankBranchDetails.rejected, (state) => {
        state.isBranchLoading = false;
      })
    .addCase(reqToGetBankStats.fulfilled, (state, action) => {
        state.isLoading = false;
        state.bankStats = action.payload;
    })
    }
})

export default bankSlice.reducer;